module.exports = __webpack_public_path__ + "img/disease.a0c1da4e.png";